import { render, staticRenderFns } from "./ContactSupport.vue?vue&type=template&id=0be26c0a"
import script from "./ContactSupport.vue?vue&type=script&lang=ts"
export * from "./ContactSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports